import { shallowMount } from "@vue/test-utils";
import OkVeridas from "@/views/OkVeridas";

describe("OkVeridas component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OkVeridas);
  });

  it("Renders del component OkVeridas", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
